<template lang="pug">

  .bars
    .bars-item.isPain
      span.bars-item__title
        .bars-item__icon
          include ../assets/img/mark.svg
        span.bars-item__name Боль
      .bars-item__progress
        .bars-item__indicator
          span
          .bars-item__indicator-fill(:style='{ transform: `translateX(${painProgress}%)` }')

      span.bars-item__shadow(:style='{ width: `${painProgress * 1.025}%` }')
      span.bars-item__status {{ pain | painometr }}

    .bars-item.isMoney
      span.bars-item__title
        .bars-item__icon
          include ../assets/img/money.svg
        span.bars-item__name Деньги
      .bars-item__progress
        .bars-item__indicator(:style='moneyProgress')
      span.bars-item__status {{ money | roubles }}
    .bars-item.isTime
      span.bars-item__title
        .bars-item__icon
          include ../assets/img/time.svg
        span.bars-item__name Время
      .bars-item__progress
        .bars-item__indicator(:style='timeProgress')
      span.bars-item__status {{ time | months }}

</template>

<script>

  export default {
    name: 'Bars',
    props: {
      status: {
        type: Object,
        required: true
      }
    },
    computed: {
      money() {
        return Math.round(this.status.money);
      },
      time() {
       return Math.round(this.status.time);
      },
      pain() {
        return Math.round(this.status.pain);
      },
      moneyProgress() {
        let progress = (this.money / this.$store.state.constants.money) * 100;
        return { width: `${progress}%` };
      },
      timeProgress() {
        let progress = (this.time / this.$store.state.constants.time) * 100;
        return { width: `${progress}%` };
      },
      painProgress() {
        let progress = 100 - (100 - this.pain);
        return progress
      },
    },
    mounted() {

    },
    filters: {
      roubles(money) {

        let formatted = `${money} тыс. ₽`;

        if(money <= 0) {
          formatted = 'Деньги закончились!';
        }

        return formatted;
      },
      months(number) {
        let titles = ['день','дня','дней']
        let cases = [2, 0, 1, 1, 1, 2];

        if(number <= 0) {
          return 'Время вышло!';
        }

        return number + ' ' + titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
      },
      painometr(value) {
        if(value > 100) {
          return 'Слишком много боли!';
        }
        return `${value}%`;
      }
     }
  }
</script>

<style lang="stylus">
.bars
  &-item
    display flex
    align-items center
    justify-content flex-start
    flex-wrap wrap
    position: relative

    min-width 13.8rem
    margin-bottom 1rem
    padding-bottom: 4px
    color: #0942E2

    font-weight 600
    font-size 1.1rem
    letter-spacing: -0.22px
    @media $tablet
      margin-bottom 2rem

      font-size: 2rem
      font-weight 500
    &:last-child
      margin-bottom 0

    &__title
      display flex
      align-items center
      order 1

      .isPain &
        color: #000

    &__status
      flex 1 0 auto
      text-align right
      order 2

      .isPain &
        color: #000

    &__icon
      width 1.2rem
      height 1.2rem
      flex-shrink 0
      margin-right 0.8rem
      color: inherit
      @media $tablet
        width 2rem
        height 2rem
      svg
        width 100%
        height 100%

    &__shadow
      position: absolute
      z-index: 0
      left: 2.5%
      bottom: 5px
      max-width: 90%
      height: 1.6rem
      box-shadow: 0 2px 12px 2px #FF036D
      background: rgba(0,0,0,0)
      transition all 1.2s 0.3s $easeOutExpo
      overflow: hidden

      @media $tablet
        height: 2rem
        /*left: 4%*/

    &__shadow[style^="width: 0%;"]
      opacity: 0

    &__progress
      height 1.8rem
      border: 2px solid #000
      margin-top 0.5rem
      order 3
      width 100%
      position: relative
      z-index: 3
      overflow: hidden

      background-color: #FFFFFF
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50)
      border-radius: 10rem

      @media $tablet
        margin-top 1rem
        height 3rem

      .isPain &
        border: 0
        border-radius 0
        box-shadow: none
        background-color: transparent

        &:after
          content: ''
          position: absolute
          top: 0
          left: 0
          width: 100%
          height: 100%
          background-color: #000
          z-index: 0
          clip-path: polygon(0% 0%, 2.35% 36%, 0.5% 65%, 1.75% 100%, 100% 100%, 97% 65%, 100% 29%, 97% 0)

        &:before
          content: ''
          position: absolute
          z-index: 1
          overflow: hidden
          top: 0
          left:2px
          width: calc(99% - 2px)
          height: 100%
          transform scale(0.965, 0.8)
          transform-origin center center
          background-color: #fff
          clip-path: polygon(0% 0%, 2.5% 35%, 0% 68%, 1% 100%, 99.5% 100%, 97% 70%, 100% 25%, 98% 0)

          @media $mobile
            will-change transform
            width: 99%

    &__indicator
      height 100%
      background-color rgb(30, 89, 253)
      background-repeat: repeat
      background-position top left
      transition: width 0.75s 0.2s $easeInOutExpo

      .isMoney &
        background-image url('~@/assets/img/time-progress-back.svg')

      .isTime &
        background-size: cover
        background-image url('~@/assets/img/pat1.svg')

      .isPain &
        position: relative
        z-index: 3
        background: none
        overflow: hidden
        width: calc(100% - 5px)
        height: calc(100% - 3.9px)
        /*margin-left: 6px*/
        margin-top: 2.1px
        margin-left: 3px
        background-color: #000
        will-change transform, width, height
        clip-path: polygon(0% 0%, 2.5% 35%, 0% 68%, 1% 100%, 99.5% 100%, 97% 70%, 100% 25%, 98% 0)

        @media $mobile
          width: calc(100% - 6px)

        @media $laptop
          width: calc(100% - 8px)
          height: calc(100% - 4px)
          margin-left: 1.25%
          margin-top: 2px

        @media $desktop
          height: calc(100% - 4px)

        span
          position: absolute
          margin: auto
          z-index: 2
          background-color #FF036D
          background-image url('~@/assets/img/pain-progress-back.svg')
          background-size: 100% center
          background-repeat: repeat-x
          overflow: hidden
          top: 0
          left:0
          width: 100%
          height: 102%
          object-fit cover

        &-fill
          position: absolute
          z-index: 3
          overflow: hidden
          top: 0
          left:0
          width: 100%
          height: 100%
          transform-origin center center
          transition all 1.2s 0.3s $easeOutExpo
          background-color: #fff
          clip-path: polygon(0% 0%, 2.5% 35%, 0% 68%, 1% 100%, 99.5% 100%, 97% 70%, 100% 25%, 98% 0)
          @media $mobile
            width: 500px

    // red style
    &_danger
      color: #FF036D
      .bars-item__indicator
        background-color rgb(255, 0, 107)
        background-size 11.6rem 1.6rem
        @media $tablet
          background-size 20.6rem 2.6rem


</style>
